export const testimonials = [
  {
    id: 1,
    name: 'Marcus J.',
    role: 'Fashion Enthusiast',
    rating: 5,
    headline: 'Finally Found the Best Nike Dunks',
    text: 'I spent months browsing random spreadsheets until I discovered PandabuySpreadsheet. The shoe section alone saved me over $300 on my last haul. Everything is organized by category and updated daily, which makes finding exactly what I want incredibly fast. My go-to resource for every single order now.',
  },
  {
    id: 2,
    name: 'Emily R.',
    role: 'TikTok Fashion Creator',
    rating: 5,
    headline: 'My Secret Weapon for Viral Finds',
    text: 'As a content creator, staying ahead of trends is everything. PandabuySpreadsheet has been my secret weapon for discovering pieces before they blow up on TikTok. The curated selection and direct links make sourcing so efficient. I have recommended this to my entire creator network.',
  },
  {
    id: 3,
    name: 'David K.',
    role: 'Streetwear Collector',
    rating: 5,
    headline: 'The Only Spreadsheet I Trust',
    text: 'I have been collecting streetwear for over five years and have tried dozens of spreadsheets. PandabuySpreadsheet is hands down the most organized and reliable one out there. The community verification system means I never waste time on dead links or low-quality sellers. Absolute game changer.',
  },
  {
    id: 4,
    name: 'Sophie L.',
    role: 'Budget-Conscious Shopper',
    rating: 5,
    headline: 'Saved Over $500 in Two Months',
    text: 'I was skeptical at first, but after using PandabuySpreadsheet for just two months, I calculated my savings at over $500 compared to buying the same styles retail. The price comparison tables help me make informed decisions every single time. Cannot recommend this enough.',
  },
  {
    id: 5,
    name: 'Alex T.',
    role: 'First-Time Agent Shopper',
    rating: 5,
    headline: 'Made My First Haul Stress-Free',
    text: 'I had no idea how to start with shopping agents until I found PandabuySpreadsheet. The guides and organized categories walked me through everything step by step. My first 8kg haul arrived perfectly because I knew exactly which sellers and items to pick from the verified listings.',
  },
  {
    id: 6,
    name: 'Jessica M.',
    role: 'Regular International Buyer',
    rating: 5,
    headline: 'Consistent Quality Every Time',
    text: 'What sets PandabuySpreadsheet apart is the consistency. I order internationally every month, and since switching to this spreadsheet, my satisfaction rate has gone from maybe 70% to nearly 100%. The daily updates mean I am always seeing fresh inventory from trusted sources.',
  },
];